import React, { createContext, useState, useContext, useEffect } from 'react';

const NetworkStatusContext = createContext({ networkEnabled: false });

export const useNetworkStatus = () => useContext(NetworkStatusContext);

/**
 * يجلب حالة ميزة السوق من الباكند عند تحميل التطبيق
 * إذا كانت networkEnabled = false ← تُخفى جميع عناصر السوق
 */
export const NetworkStatusProvider = ({ children }) => {
    const [networkEnabled, setNetworkEnabled] = useState(false);

    useEffect(() => {
        const apiBase = process.env.REACT_APP_API_URL || 'https://back.miskest.com/api/v1';
        fetch(`${apiBase}/public/features/network-status`)
            .then(res => res.json())
            .then(data => {
                if (data?.data?.networkEnabled === true) {
                    setNetworkEnabled(true);
                }
            })
            .catch(() => {
                // إذا فشل الطلب نبقي السوق مخفية
            });
    }, []);

    return (
        <NetworkStatusContext.Provider value={{ networkEnabled }}>
            {children}
        </NetworkStatusContext.Provider>
    );
};
